import { useContext } from "react";
import { Context } from "../services/auth";

export const useAuth = () => useContext(Context);
